import styled from 'styled-components';

export const BarRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.level3};
  margin-left: auto;
  min-width: 0;
`;

export const StaleNote = styled.span`
  ${({ theme }) => theme.font.bodySmall};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;
